import { trackOmniture } from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import { getSelectedLanguageCode } from '../../vernacular/VernacularConfig';


export const LANDING_PAGE_NAME = 'mob_rail_landing';
interface TrackType {
  clickEvent: string;
}interface LangCodeMap {
  [key: string]: TrackType;
}
export const langCodeMap: LangCodeMap = {
  hi: {
    clickEvent: 'mob_rail_landing_hindi_selected_click',
  },
  en: {
    clickEvent: 'mob_rail_landing_eng_selected_click',
  },
};

export function trackClickEvent(eventName: string, pageName = LANDING_PAGE_NAME) {
  const params = {
    pageName,
    m_v15: pageName,
    m_c61: eventName,
    m_v24: 'rails'
  };
  trackOmniture(pageName, params);
}

export function trackPageLoad(eventName: string, pageName = LANDING_PAGE_NAME) {
  const params = {
    pageName,
    m_v15: eventName,
    m_v24: 'rails'
  };
  trackOmniture(pageName, params);
}